import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ServiceIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(11.000000, 6.000000)">
          <polygon
            fill="#ffffff"
            className={styles.white}
            points="25.105581 8.7665 27.105581 13.7665 26.693581 17.7965 26.693581 27.0065 16.105581 31.7665 2.507581 28.4015 2.105581 12.7665 3.105581 8.7665"
          ></polygon>
          <g>
            <g transform="translate(2.807181, 0.000000)">
              <path
                d="M23.571,11.232 L23.571,11.232 C23.115,4.953 18.018,0 11.782,0 C5.6,0 0.532,4.866 0,11.067"
                fill="#ffffff"
                className={styles.white}
              ></path>
              <path
                d="M23.571,11.232 L23.571,11.232 C23.115,4.953 18.018,0 11.782,0 C5.6,0 0.532,4.866 0,11.067"
                stroke="#000000"
                className={styles.defaultStrokeColor}
                strokeWidth="2"
              ></path>
            </g>
            <path
              d="M2.031981,38.7256 C0.841981005,38.7256 -0.124018995,37.6996 0.0129810046,36.5176 C0.979981005,28.2236 7.319981,21.8186 14.995981,21.8186 C22.671981,21.8186 29.010981,28.2236 29.977981,36.5176 C30.115981,37.6996 29.149981,38.7256 27.958981,38.7256 L2.031981,38.7256 Z"
              fill="#ffffff"
              className={styles.white}
            ></path>
            <path
              d="M2.031981,38.7256 C0.841981005,38.7256 -0.124018995,37.6996 0.0129810046,36.5176 C0.979981005,28.2236 7.319981,21.8186 14.995981,21.8186 C22.671981,21.8186 29.010981,28.2236 29.977981,36.5176 C30.115981,37.6996 29.149981,38.7256 27.958981,38.7256 L2.031981,38.7256 Z"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinejoin="round"
              strokeWidth="2"
            ></path>
            <path
              d="M19.574381,11.78 C17.595381,10.468 16.241381,8.67 15.723381,6.915 C15.378381,9.057 13.528381,11.299 10.764381,12.597 C9.318381,13.276 7.831381,13.598 6.474381,13.594 C6.334381,14.24 6.252381,14.909 6.252381,15.601 C6.252381,20.467 9.937381,24.412 14.483381,24.412 C19.029381,24.412 22.714381,20.467 22.714381,15.601 C22.714381,14.732 22.592381,13.894 22.373381,13.102 C21.434381,12.82 20.483381,12.382 19.574381,11.78"
              fill="#ffffff"
              className={styles.white}
            ></path>
            <path
              d="M19.574381,11.78 C17.595381,10.468 16.241381,8.67 15.723381,6.915 C15.378381,9.057 13.528381,11.299 10.764381,12.597 C9.318381,13.276 7.831381,13.598 6.474381,13.594 C6.334381,14.24 6.252381,14.909 6.252381,15.601 C6.252381,20.467 9.937381,24.412 14.483381,24.412 C19.029381,24.412 22.714381,20.467 22.714381,15.601 C22.714381,14.732 22.592381,13.894 22.373381,13.102 C21.434381,12.82 20.483381,12.382 19.574381,11.78 Z"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M14.979181,20.4406 C16.207181,21.4156 17.904181,22.0186 19.779181,22.0186 C23.527181,22.0186 26.566181,19.6066 26.566181,16.6326"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeWidth="2"
            ></path>
            <path
              d="M12.105581,20.2665 C12.105581,18.8855 13.224581,17.7665 14.605581,17.7665 C15.986581,17.7665 17.105581,18.8855 17.105581,20.2665 C17.105581,21.6475 15.986581,22.7665 14.605581,22.7665 C13.224581,22.7665 12.105581,21.6475 12.105581,20.2665"
              fill="#0050B3"
              className={styles.interactiveColor}
            ></path>
            <path
              d="M26.444581,17.8246 L26.444581,17.8246 C27.363581,17.8246 28.108581,17.0796 28.108581,16.1606 L28.108581,11.9006 C28.108581,10.9816 27.363581,10.2366 26.444581,10.2366 L26.444581,10.2366 C25.525581,10.2366 24.780581,10.9816 24.780581,11.9006 L24.780581,16.1606 C24.780581,17.0796 25.525581,17.8246 26.444581,17.8246"
              fill="#00000"
              className={styles.defaultColor}
            ></path>
            <path
              d="M26.444581,17.8246 L26.444581,17.8246 C27.363581,17.8246 28.108581,17.0796 28.108581,16.1606 L28.108581,11.9006 C28.108581,10.9816 27.363581,10.2366 26.444581,10.2366 L26.444581,10.2366 C25.525581,10.2366 24.780581,10.9816 24.780581,11.9006 L24.780581,16.1606 C24.780581,17.0796 25.525581,17.8246 26.444581,17.8246 Z"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M2.681381,17.8246 L2.681381,17.8246 C3.600381,17.8246 4.345381,17.0796 4.345381,16.1606 L4.345381,11.9006 C4.345381,10.9816 3.600381,10.2366 2.681381,10.2366 L2.681381,10.2366 C1.762381,10.2366 1.017381,10.9816 1.017381,11.9006 L1.017381,16.1606 C1.017381,17.0796 1.762381,17.8246 2.681381,17.8246"
              fill="#00000"
              className={styles.defaultColor}
            ></path>
            <path
              d="M2.681381,17.8246 L2.681381,17.8246 C3.600381,17.8246 4.345381,17.0796 4.345381,16.1606 L4.345381,11.9006 C4.345381,10.9816 3.600381,10.2366 2.681381,10.2366 L2.681381,10.2366 C1.762381,10.2366 1.017381,10.9816 1.017381,11.9006 L1.017381,16.1606 C1.017381,17.0796 1.762381,17.8246 2.681381,17.8246 Z"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M22.251081,23.6959 C21.046081,25.8679 18.008081,27.4099 14.450081,27.4099 C11.043081,27.4099 8.113081,25.9969 6.813081,23.9699"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <g transform="translate(26.105581, 15.766500)">
              <line fill="#ffffff" className={styles.white} x1="0.5" x2="0.5" y1="0" y2="12"></line>
              <line
                stroke="#000000"
                className={styles.defaultStrokeColor}
                x1="0.5"
                x2="0.5"
                y1="0"
                y2="12"
              ></line>
            </g>
            <g transform="translate(2.105581, 15.766500)">
              <line fill="#ffffff" className={styles.white} x1="0.5" x2="0.5" y1="0" y2="13"></line>
              <line
                stroke="#000000"
                className={styles.defaultStrokeColor}
                x1="0.5"
                x2="0.5"
                y1="0"
                y2="13"
              ></line>
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
